module.exports = __webpack_public_path__ + "static/media/pinterest.dd4d80cb.png";